export default __webpack_public_path__ + "static/media/future.4ecea994.png";